



















import { Vue, Component, Prop } from 'vue-property-decorator'
import { PdState, PdGroupList } from '@/store/pd/types'
import {
  PdSettingPropTypes,
  QuantitySettingNames,
  FormattedPdSetting,
  QuantitySettingItem
} from '@/store/pdSetting/types'
import { PdQuantityPropertyNames } from '@/types/pd'
import { capitalize } from '@/utils/string'
import { round } from '@/utils/math'
import { ExStore } from 'vuex'

@Component
export default class PdTabQuantityItem extends Vue {
  @Prop({ type: Object, required: true }) pdGroups!: PdGroupList
  @Prop({ type: Array, required: true }) datetimeSort!: Array<string>
  @Prop({ type: String, required: true }) type!: PdQuantityPropertyNames
  @Prop({ type: String, required: true }) title!: string

  readonly pdSettingTypes: Array<PdSettingPropTypes> = ['emg', 'warn']

  $store!: ExStore

  get formattedPdSetting() {
    return this.$store.getters['pdSetting/format']
  }

  capitalize(str: string) {
    return capitalize(str)
  }

  getQuantityItemText(pd: Array<PdState>, name: PdQuantityPropertyNames) {
    if (pd.some(p => p[name] !== null)) {
      const sum = pd.reduce((sum, p) => sum + (p[name] || 0), 0)
      if (name === 'weight') {
        return round(sum / pd.filter(p => p[name]).length, 1)
      } else {
        return sum
      }
    }

    return ''
  }

  getQuantitySettingText(setting: QuantitySettingItem) {
    const parts = []

    if (setting.low !== null) {
      parts.push(`${setting.low} ＜値`)
    }

    if (setting.high !== null) {
      if (parts.length === 0) {
        parts.push('値')
      }

      parts.push(`＜ ${setting.high}`)
    }

    return parts.join('')
  }

  getItemClass(name: PdQuantityPropertyNames, pd: Array<PdState>) {
    if (pd.length > 1) {
      return ''
    }

    if (!this.formattedPdSetting) {
      return ''
    }

    if (pd[0][name] === null) {
      return ''
    }

    const settings = this.formattedPdSetting as FormattedPdSetting
    const value = pd[0][name] as number
    if (
      (Object.keys(settings) as Array<keyof FormattedPdSetting>).some(key => {
        const setting =
          settings[key][`limit${capitalize(name)}` as QuantitySettingNames]

        if (setting.on === 0 || setting.low === null) {
          return false
        }

        return setting.low > value
      })
    ) {
      return 'under'
    }

    if (
      (Object.keys(settings) as Array<keyof FormattedPdSetting>).some(key => {
        const setting =
          settings[key][`limit${capitalize(name)}` as QuantitySettingNames]

        if (setting.on === 0 || setting.high === null) {
          return false
        }

        return setting.high < value
      })
    ) {
      return 'over'
    }
  }
}
